import React from "react";
import { connect } from "react-redux";
import Message from "./Message";

import './Billboard.css';
import { BillboardMessage, publishMessage } from "../../redux/actions/billboard";
import { GlobalState } from "../../redux/types";
import { BillboardState } from "../../redux/reducers/billboard";



const Billboard = ((props:BillboardState) => (
    <div className='billboard'>
        {props.messages && props.messages.map((message)=><Message key={message.id}{...message}/>)}
    </div>
));

const mapStateToProps = (state:GlobalState) => ({
    messages: state.billboard.messages
});


export default connect(mapStateToProps, undefined)(Billboard);

export type BillboardProps = {
    publishMessage: (message: BillboardMessage) => void
};

export const withBillboard = connect(undefined, dispatch => ({
    publishMessage: (message:BillboardMessage) => dispatch(publishMessage(message))
}));
